import {useState} from "react";
import {DateRangePicker, LocalizationProvider} from "@mui/x-date-pickers-pro";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {dateToString, parseDDMMYYYY} from "../../Utils/dateUtils";
import {IconButton, Tooltip} from "@mui/material";
import {Clear} from "@mui/icons-material";
import Box from "@mui/material/Box";
export function DateRangeColumnFilter({column: {filterValue, setFilter}}) {
    let _range = [null, null];

    if (filterValue?.range) {
        _range = filterValue.range;
    } else if (Array.isArray(filterValue)) {
        _range = [parseDDMMYYYY(filterValue[0]), parseDDMMYYYY(filterValue[1])];
    }

    const [range, setRange] = useState(_range);

    const formatDisplayValue = () => {
        if (range[0] && range[1]) {
            return `${dateToString(range[0])} - ${dateToString(range[1])}`;
        }
        return '';
    };

    const handleDateChange = (newValue) => {
        if ((newValue[0] !== null && newValue[1] !== null)) {
            setRange(newValue);
            let formattedDates = [dateToString(newValue[0]), dateToString(newValue[1])];
            setFilter(formattedDates);
        } else {
            setFilter(undefined);
        }
    };

    const handleClear = () => {
        setRange([null, null]);
        setFilter(undefined);
    };
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateRangePicker
                disableOpenPicker={false}
                value={range}
                inputFormat="dd/MM/yyyy"
                className="date-range-picker"
                onChange={(newValue) => handleDateChange(newValue)}
                renderInput={(startProps) => {
                    // Remove error, focused and inputProps to avoid warnings
                    const { error, focused, inputProps, InputProps, ...cleanProps } = startProps;
                    return (
                    <>
                        <input
                            {...cleanProps}
                            value={formatDisplayValue()}
                            placeholder="Select date range"
                            style={{width: "100%"}}
                            onChange={() =>{}} //writing empty onChange method doesn't show warning in browser console
                        />
                        <Box sx={{
                            position: 'relative',
                            top: '15%',
                            display: 'flex',
                            gap: '4px'
                        }}>
                            {range[0] && range[1] && (
                                <Tooltip title="Clear dates">
                                    <IconButton
                                        size="small"
                                        onClick={handleClear}
                                        sx={{
                                            padding: '2px',
                                            '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                                        }}
                                    >
                                        <Clear fontSize="small"/>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>
                    </>
                    )
                }}
            />
        </LocalizationProvider>
    )
}